import { observer } from "mobx-react-lite";
import * as React from "react";
import { cn } from "ui";

import { QuestionnaireSubmissionSection } from "src/components/QuestionnaireSubmissionSection";

import { useAnswerQuestion } from "./hooks/useAnswerQuestion";
import { QuestionnaireItemRenderer } from "./QuestionnaireItemRenderer";
import { useQuestionnaireSubmissionContext } from "./QuestionnaireSubmissionContext";

interface Props {
  itemId: string;
  disabled: boolean;
}

export const SubmissionItem = observer(function SubmissionItem(props: Props) {
  const answerQuestion = useAnswerQuestion();
  const questionnaireSubmissionContext = useQuestionnaireSubmissionContext();
  const item = questionnaireSubmissionContext.itemsById[props.itemId];

  if (item.section) {
    return (
      <div className="border rounded-md p-6">
        <QuestionnaireSubmissionSection {...props} />
      </div>
    );
  }

  const question = item.question;

  if (!question) {
    return null;
  }

  const hasError = questionnaireSubmissionContext.hasErrorQuestion(item.id);
  const answer =
    questionnaireSubmissionContext.allAnswersByQuestionId[question.id];

  return (
    <React.Fragment key={item.id}>
      <div
        data-questionnaire-item-id={props.itemId}
        className={cn("px-6 py-6 bg-white border rounded-md", {
          "border border-red-400": hasError,
        })}
      >
        <QuestionnaireItemRenderer
          item={item}
          value={
            answer
              ? {
                  value: answer.value || undefined,
                  optionIds:
                    questionnaireSubmissionContext.getQuestionOptionsAnswer(
                      question.id,
                    ),
                  confirmed: answer.confirmed || undefined,
                  otherOptionValue: answer.otherOptionValue || undefined,
                }
              : undefined
          }
          onChange={(value) => {
            answerQuestion.perform({
              questionId: question.id,
              value: value.value,
              options: value.optionIds?.map((id) => ({ id })),
              confirmed: value.confirmed,
              otherOptionValue: value.otherOptionValue,
            });
          }}
          disabled={props.disabled}
        />
      </div>
    </React.Fragment>
  );
});
